import React from 'react'

export default function Unemployment() {
  return (
    <div>Unemployment</div>
  )
}
